<script lang="ts">
    import Fa from 'svelte-fa'
    import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
    import { onDestroy, onMount } from 'svelte/internal'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import DateSelect from '../_common/date-select.svelte'
    import dayjs from 'dayjs'
    import { SearchesRepository } from '../../modules/prospectApi/searches/searches.repository'
    import { SearchesService } from '../../modules/prospectApi/searches/searches.service'
    import { Search } from '../../modules/prospectApi/searches/search'
    import type { CreateSearchDto } from '../../modules/prospectApi/searches/dto/create-searches.dto'
    import ProspectCitySelect from './prospect-city-select.svelte'
    import ProspectCategorySelect from './prospect-category-select.svelte'
    import type { City } from '../../modules/prospectApi/cities/city'
    import { CitiesRepository } from '../../modules/prospectApi/cities/cities.repository'
    import { CitiesService } from '../../modules/prospectApi/cities/cities.service'
    import { navigateTo } from 'yrv'

    // let limits: number[] = [0, 50, 100, 200, 300, 400, 500, 800, 1000, 2000, 5000, 99999]

    let limits: { value: number; label: string }[] = []
    limits.push({ value: 0, label: '0' })
    limits.push({ value: 50, label: '50' })
    limits.push({ value: 100, label: '100' })
    limits.push({ value: 200, label: '200' })
    limits.push({ value: 300, label: '300' })
    limits.push({ value: 400, label: '400' })
    limits.push({ value: 500, label: '500' })
    limits.push({ value: 800, label: '800' })
    limits.push({ value: 1000, label: '1000' })
    limits.push({ value: 2000, label: '2000' })
    limits.push({ value: 5000, label: '5000' })
    limits.push({ value: 99999, label: 'Sem limite' })

    const entityRep = new SearchesRepository()
    const searchesS = new SearchesService(entityRep)

    const cityRep = new CitiesRepository()
    const cityS = new CitiesService(cityRep)

    const POPULATIONLIMITS = [0, 10000, 25000, 50000, 100000, 150000, 200000, 300000, 400000, 500000]
    let populationLimit = 0

    const UFs = [
        'AC',
        'AL',
        'AP',
        'AM',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MT',
        'MS',
        'MG',
        'PA',
        'PB',
        'PR',
        'PE',
        'PI',
        'RJ',
        'RN',
        'RS',
        'RO',
        'RR',
        'SC',
        'SP',
        'SE',
        'TO',
    ]
    let uf = ''
    let show = false
    let step = 1
    let entities: Search[] = []
    let entity: Search = new Search()
    let total = 0

    let dates: { from: Date; to: Date } = window.api.utils.dates.currentMonth()

    let chartContainer
    let options = {}
    let timer = null

    let cities: City[] = []
    let citiesSelected = []
    let citiesProspected = []

    let reprospect = false

    async function onReprospect() {
        await loadCitiesFromUF()
    }

    onMount(async () => {
        await loadEntities()
    })

    onDestroy(() => {
        if (timer) clearTimeout(timer)
    })

    function dateChanged(event) {
        dates = event.detail
        loadEntities()
    }

    async function loadEntities() {
        try {
            show = true
            total = 0
            step = 1
            const dt = {
                from: dates?.from || undefined,
                to: dates?.to || undefined,
                childs: true,
            }
            if (timer) {
                clearTimeout(timer)
            }
            entities = await searchesS.getAll(dt)
            total = entities.reduce((total, item) => {
                if (item.total) total += item.total
                return total
            }, 0)
            for (const ent of entities) {
                if (ent.status === 60) {
                    timer = setTimeout(() => {
                        if (step === 1) loadEntities()
                    }, 30000)
                    break
                }
                if (ent.status === 65) {
                    timer = setTimeout(() => {
                        if (step === 1) loadEntities()
                    }, 120000)
                    break
                }
            }
            entities = entities
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function editEntity(id: string) {
        try {
            show = true
            entity = await searchesS.getOne(id, { childs: true })
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new Search()
        entity.limit = 99999
        step = 2
    }

    async function saveEntity() {
        //createEntity()
        createMultipleEntities()
    }

    async function checkDuplicity(cityId: string, categoryId: string) {
        if (!cityId || !categoryId) return false
        const result = await searchesS.getAll({ cityId, categoryId })
        return result.length > 0
    }

    function wasProspected(cityId) {
        let date: Date = null
        for (const city of citiesProspected) {
            if (city.cityId === cityId) {
                city.createdAt = new Date(city.createdAt)
                if (!date || date.getTime() < city.createdAt.getTime()) date = city.createdAt
            }
        }
        //return !!citiesProspected.find((el) => el.cityId === cityId)
        return date
    }

    async function loadProspectedCities() {
        citiesProspected = []
        if (!entity.categoryId) return false
        citiesProspected = await searchesS.getAll({ categoryId: entity.categoryId })
        console.log('citiesProspected', citiesProspected)
    }

    async function loadCitiesFromUF() {
        cities = []
        citiesSelected = []
        if (!uf) {
            return
        }
        cities = await cityS.getAll({ state: uf })
        cities = cities.filter((el) => el.population >= populationLimit)
        console.log('cities', uf, cities)
    }

    async function restartSearch(searchId: string) {
        await searchesS.restart(searchId)
        await loadEntities()
    }

    async function onCategoryChange(categoryId) {
        console.log('onCategoryChange', categoryId)
        uf = ''
        cities = []
        citiesSelected = []
        if (categoryId) {
            await loadProspectedCities()
        }
    }

    async function onUFChange(uf) {
        console.log('onUFChange', uf)
        cities = []
        citiesSelected = []
        if (uf) {
            loadCitiesFromUF()
        }
    }

    async function createEntity() {
        try {
            if (show) return
            show = true
            const dto: CreateSearchDto = {
                categoryId: entity.categoryId,
                cityId: entity.cityId,
                limit: entity.limit,
            }
            if (!validateDto(dto)) return
            if (await checkDuplicity(entity.cityId, entity.categoryId)) {
                if (!confirm('Você já realizou uma busca idêntica. Deseja mesmo repetir?')) return
            }
            entity = await searchesS.create(dto)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function createMultipleEntities() {
        try {
            if (show) return
            show = true
            //validation
            for (const cityId of citiesSelected) {
                const dto: CreateSearchDto = {
                    categoryId: entity.categoryId,
                    cityId: cityId,
                    limit: entity.limit,
                }
                if (!validateDto(dto)) return
            }
            // submit
            let count = 0
            for (const cityId of citiesSelected) {
                const dto: CreateSearchDto = {
                    categoryId: entity.categoryId,
                    cityId: cityId,
                    limit: entity.limit,
                }
                await searchesS.create(dto)
                count += 1
                if (count === 50) break
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function validateDto(dto: CreateSearchDto) {
        if (!dto.categoryId) {
            evaluateError('Informe a categoria')
            return false
        }
        if (dto.cityId.length === 0) {
            evaluateError('Informe a cidade a ser buscada')
            return false
        }
        if (dto.limit === 0) {
            evaluateError('Informe o limite máximo de contatos a serem buscados')
            return false
        }
        return true
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este item?')) {
            return
        }
        try {
            show = true
            await searchesS.remove(entity.searchId)
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function showEntities() {
        step = 1
    }

    function evaluateError(error) {
        window.error(error)
    }

    function statusLabel(status: number) {
        if (status === 5) return 'erro'
        if (status === 10) return 'Cancelado'
        if (status === 60) return 'Na fila'
        if (status === 65) return 'Prospectando'
        if (status === 90) return 'Enriquecendo'
        if (status === 100) return 'Pronto'
    }

    function friendlyCity(city) {
        let str = city.name.padEnd(30, ' ')
        str += city.population.toLocaleString('pt-BR').padStart(11, ' ') + ' habitantes'
        const prospected = wasProspected(city.cityId)
        if (prospected) {
            str += ' / prospectada em ' + dayjs(prospected).format('DD/MM/YYYY')
        }
        console.log('str', str)
        str = str.replaceAll(' ', '&nbsp;')
        return str
    }

    function showProspect(searchId) {
        navigateTo('/prospect/filter?searchId=' + searchId)
    }

    function addToAudience(searchId) {}

    $: {
        onCategoryChange(entity.categoryId)
    }

    $: {
        onUFChange(uf)
    }

    $: {
        onPopulationLimitChange(populationLimit)
    }

    async function onPopulationLimitChange(populationLimit: number) {
        await loadCitiesFromUF()
    }
</script>

{#if step === 1}
    <Content>
        <div class="grid-act">
            <DateSelect startFrom={dates.from} startTo={dates.to} on:change={dateChanged} />
            <div class="spacer h-mobile" />
            <button class="btn btn-primary" on:click={newEntity}><Fa icon={faPlusCircle} /> Nova busca</button>
        </div>
        <div class="grid-head">
            <div class="row">
                <div class="col-2">Data</div>
                <div class="col-1">Status</div>
                <div class="col">Categoria</div>
                <div class="col">Cidade</div>
                <!-- <div class="col-md-1 text-end">Limite</div> -->
                <div class="col-md-1 text-end">Resultados</div>
                <div class="col-md-2 text-end">&nbsp;</div>
            </div>
        </div>
        <div class="grid-body mb-5 pb-5">
            {#each entities as item}
                <div class="row line liner py-1">
                    <div class="col-2" title={dayjs(item.createdAt).format('DD/MM/YYYY HH:mm')}>
                        {dayjs(item.createdAt).format('DD/MM/YYYY HH:mm')}
                    </div>
                    <div class="col-md-1"><div class="badge status-{item.status}">{statusLabel(item.status)}</div></div>
                    <div class="col">{item.category?.name}</div>
                    <div class="col">{item.city?.name}</div>
                    <!-- <div class="col-md-1 text-end">{item.limit >= 99999 ? 'Sem limite' : item.limit}</div> -->
                    <div class="col-md-1 text-end">{item.status < 90 ? '-' : item.total}</div>
                    <div class="col-md-2 text-end">
                        {#if item.status >= 90}
                            {#if item.total === 0 && dayjs(new Date()).diff(item.finishedAt, 'minutes') >= 60}
                                <button
                                    class="btn btn-secondary btn-sm"
                                    on:click={() => {
                                        restartSearch(item.searchId)
                                    }}>Buscar novamente</button
                                >
                            {:else}
                                <a class="btn btn-secondary btn-sm" href="/prospect/filter?searchId={item.searchId}">Abrir</a>
                            {/if}
                        {/if}
                    </div>
                </div>
            {/each}
            <div class="row line">
                <div class="col-2" />
                <div class="col-md-1" />
                <div class="col" />
                <div class="col" />
                <!-- <div class="col-md-1 text-end"></div> -->
                <div class="col-md-1 text-end">Total {total}</div>
                <div class="col-md-2 text-end" />
            </div>
        </div>
        <LoadSpinner {show} />
    </Content>
{/if}
{#if step === 2}
    <Content>
        <div class="grid-act">
            <button class="btn btn-secondary" on:click={showEntities}>Voltar</button>
            <div class="spacer" />
            {#if entity.searchId}
                <button class="btn btn-caution" on:click={removeEntity}>Excluir</button>
            {/if}
            <button class="btn btn-primary" on:click={saveEntity}>Salvar</button>
        </div>
        <div class="grid-form">
            <div class="row">
                <div class="col-md-12">
                    <ProspectCategorySelect label="Categoria" bind:categoryId={entity.categoryId} />
                </div>
                <div class="col-md-4 h-all">
                    <div class="input-group">
                        <label for="" class="input-group-text">Limite de resultados</label>
                        <select name="" id="" class="form-select" bind:value={entity.limit}>
                            {#each limits as limit, i}
                                <option value={limit.value}>{limit.label}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            {#if !!entity.categoryId}
                <div class="row">
                    <div class="col-md-4">
                        <div class="input-group">
                            <label for="" class="input-group-text">Estado</label>
                            <select name="" id="" class="form-select" bind:value={uf}>
                                {#each UFs as UF, i}
                                    <option value={UF}>{UF}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="input-group">
                            <label for="" class="input-group-text">Mínimo de habitantes</label>
                            <select name="" id="" class="form-select" bind:value={populationLimit}>
                                {#each POPULATIONLIMITS as POPULATIONLIMIT, i}
                                    <option value={POPULATIONLIMIT}>{POPULATIONLIMIT.toLocaleString('pt-BR')}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4 d-flex align-items-center">
                        <div class="form-check form-switch">
                            <input class="form-check-input" bind:checked={reprospect} on:change={onReprospect} type="checkbox" role="switch" id="agenda" />
                            <label class="form-check-label" for="agenda">Permitir prospectar uma cidade novamente</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="input-group">
                            <label for="" class="input-group-text">Cidades</label>
                            <select multiple size="20" name="" id="" class="form-select form-cities" bind:value={citiesSelected}>
                                {#each cities as city, i}
                                    <option value={city.cityId} disabled={!reprospect && !!wasProspected(city.cityId)}>{@html friendlyCity(city)}</option>
                                {/each}
                            </select>
                        </div>
                        <div class="text-muted">
                            {citiesSelected.length} cidades selecionadas.<br />
                            Segure CTRL para selecionar mais de uma cidade. Limite de 10 por pesquisa. Caso selecione mais, apenas as 10 primeiras serão consideradas.
                        </div>
                    </div>
                </div>
            {/if}
        </div>
    </Content>
{/if}

<style>
    .status-10 {
        background-color: #666666;
    }

    .status-60 {
        background-color: #b78505;
    }
    .status-65 {
        background-color: #379e75;
    }
    .status-90 {
        background-color: #728af4;
    }
    .status-100 {
        background-color: #5067d2;
    }

    .form-cities {
        font-family: 'Courier New';
    }
</style>
